/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/searching"/>
import { IRejectionManagementReasonCode } from "./interfaces";

export const searchRejectionManagementReasonCodes = (items: IRejectionManagementReasonCode[], phrase: string) => {
    if (phrase === "") {
        return items;
    }

    const expression = new RegExp(escapeRegex(phrase), "gi");

    return items.filter(
        (item) => 
            item.reasonCode.search(expression) > -1 ||
            item.description.search(expression) > -1 ||
            item.types.some(type => type.search(expression) > -1)
    );
};

export const escapeRegex = (s: string) => s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');